<template>
	<transition-group
		ref="container"
		:style="{ minHeight: `${containerHeight}px` }"
		class="row"
		tag="div"
		name="gallery"
		@after-enter="updateHeight"
		@before-leave="updateHeight"
	>
		<div v-for="item in items" :key="item.ID" class="columns column3">
			<gallery-item :item="item" />
		</div>
	</transition-group>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

const containerHeight = ref('265');

const updateHeight = (el) => {
	const item = el.querySelector('.gallery-item');
	containerHeight.value = item.offsetHeight;
};

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss">
.gallery-move {
	transition: transform 0.5s;
}

.gallery-enter-active {
	transition: all 0.3s ease-out;
}

.gallery-leave-active,
.gallery-enter {
	position: absolute;
	opacity: 0;
}

.gallery-enter {
	transform: translateY(10px);
}
</style>

<style lang="scss" scoped>
.row {
	max-width: 1250px;
}

.columns {
	padding: 0;
}

@media (max-width: 900px) {
	.row {
		max-width: 650px !important;
	}
}

@media (max-width: 640px) {
	.row {
		max-width: 320px !important;
	}
}
</style>
